import { Component, inject } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { TipoEmpresa } from '@app/models/tipo-empresa';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-nueva-empresa',
    templateUrl: './nueva-empresa.component.html',
    styleUrl: './nueva-empresa.component.scss',
    standalone: false
})
export class NuevaEmpresaComponent {
    config = inject(DynamicDialogConfig);
    ref = inject(DynamicDialogRef);

    ngOnInit(): void {
        this.tipoEmpresas = this.config.data?.opcionesSelect ?? [];
    }

    form = new FormGroup({
        nombre: new FormControl('', Validators.required),
        tipo_empresa: new FormControl('', Validators.required)
    });

    tipoEmpresas: TipoEmpresa[] = [];

    isValid = true;

    checkValid() {
        this.isValid = true;
        this.isValid = this.form.valid;
    }

    confirmar() {
        this.checkValid();
        if (this.form.valid) {
            const nuevaEmpresa = {
                ...this.form.value
            };
            // Devuelve la nueva empresa al histórico (componente padre)
            this.ref.close(nuevaEmpresa);
        } else {
            this.form.markAllAsTouched(); // Marca los campos para mostrar errores
        }
    }

    // DEVUELVE SIN CAMBIOS
    cancelar() {
        this.ref.close();
    }
}
